import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { logoutUser } from "../../controller/c_auth";
import { useAppDispatch } from "../../app/hooks";
import { useEffect } from "react";
export default function AdminTopbar({ onToggleSidebar }) {
  const dispatch = useAppDispatch();
const navigate=useNavigate();
const authState=useSelector((state)=>state.auth);
const userid=authState.login.userid;
const status=authState.login.loginstatus;
useEffect(() => {
  // Redirect to login when userid becomes falsy
  if (userid===null || status===false) {
    dispatch({ type: "auth/logout" });
    navigate('/login');
  }
}, [userid, dispatch, navigate, status]);
const handleLogout=async()=>{
  try {
    await logoutUser(authState.login.userid);
    dispatch({ type: "auth/logout" });
    navigate('/login');
  } catch (error) {
    console.error("Logout failed:", error);
  }
};
  return (
    <header className="admin-topbar">
      <div className="container-fluid px-3 px-lg-4">
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-outline-light d-lg-none"
              onClick={onToggleSidebar}
              aria-label="Open sidebar"
            >
              <i className="bi bi-list" />
            </button>

            <div className="d-none d-md-block">
              <div className="fw-bold lh-1">Admin Dashboard</div>
              <div className="small text-white-50">Manage platform content</div>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <div className="admin-search d-none d-md-flex">
              <i className="bi bi-search text-white-50" aria-hidden="true" />
              <input className="admin-search__input" placeholder="Search..." />
            </div>

            <button type="button" className="btn btn-outline-light" aria-label="Notifications">
              <i className="bi bi-bell" />
            </button>

            <div className="dropdown">
              <button
                className="btn btn-outline-light dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-person-circle me-2" />
                {authState.login.userfullname}
              </button>

              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-dark">
                <li>
                  <button className="dropdown-item" type="button">
                    <i className="bi bi-person me-2" />
                    Profile
                  </button>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item text-danger" type="button" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-2" />
                    Logout
                  </button>
                </li>
              </ul>
            </div>

            <div className="admin-avatar d-none d-md-grid" aria-hidden="true">
              A
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
